import {View} from 'MWC';
import tpl from '../templates/energy-list.jsx';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView.js';
import {canUseDOM} from '../../../../../helpers/canUseDOM.js';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            showModal2: false
        };
    }

    componentDidMount() {
        super.componentDidMount();

        if (!canUseDOM) return;

        const params = new URLSearchParams(window.location.search);

        if (params.has('proposal')) {
            this.toggleModal2();
        }
    }

    toggleModal2 = () => {
        const willOpen = !this.state.showModal2;
        this.setState({showModal2: willOpen});

        document.body.classList.toggle('disable-scroll', willOpen);
    };
}
